import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { PHONE_NUMBER_MASKS, PHONE_NUMBER_RULES } from "./Constants";

const CountryPhoneInput = ({
  countryCodeFieldName = "",
  phoneFieldName = "",
  countryCode = "+61",
  phoneNumber = "",
  onPhoneChange,
  onCountryChange,
  placeholder,
  inputStyle = {},
  disabled,
  allowedCountry,
}) => {
  const [value, setValue] = useState(
    `${countryCode ? countryCode?.replace("+", "") : "61"}${(
      phoneNumber ?? ""
    ).replace(/\D/g, "")}`
  );
  const ALLOWED_COUNTRIES =
    Array.isArray(allowedCountry) && allowedCountry?.length
      ? allowedCountry
      : [
          "gb", // +44
          "au", // +61
          "nz", // +64
          "in", // +91
          "ie", // +353
          "fr", // +33
          "us", // +1
          "ca", // +1
          "de", // +49
          "it", // +39
          "es", // +34
          "pt", // +351
          "at", // +43
          "ch", // +41
        ];
  const digitsOnlyPhoneNumber = phoneNumber
    ? phoneNumber.replace(/\D/g, "")
    : phoneNumber;

  const country = PHONE_NUMBER_RULES[countryCode]
    ? PHONE_NUMBER_RULES[countryCode]?.country
    : "au";

  useEffect(() => {
    setValue(
      `${countryCode ? countryCode?.replace("+", "") : "61"}${(
        phoneNumber ?? ""
      ).replace(/\D/g, "")}`
    );
  }, [countryCode, phoneNumber]);

  return (
    <PhoneInput
      onlyCountries={ALLOWED_COUNTRIES}
      country={country}
      countryCodeEditable={false}
      value={value}
      jumpCursorToEnd={false}
      disabled={disabled}
      onChange={(val, data) => {
        const countryCodeOnly = data.dialCode?.startsWith("+")
          ? data?.dialCode
          : `+${data.dialCode}`;
        const phoneNumberOnly = val.replace(data?.dialCode).replace(/\D/g, "");

        if (
          digitsOnlyPhoneNumber != phoneNumberOnly &&
          typeof onPhoneChange == "function"
        ) {
          onPhoneChange({
            target: {
              name: phoneFieldName,
              value: phoneNumberOnly,
            },
          });
        }
        if (
          countryCode != countryCodeOnly &&
          typeof onCountryChange == "function"
        ) {
          onCountryChange({
            target: {
              name: countryCodeFieldName,
              value: countryCodeOnly,
            },
          });
        }
      }}
      placeholder={placeholder}
      containerStyle={{
        width: "100%",
      }}
      masks={PHONE_NUMBER_MASKS}
      buttonStyle={{
        borderColor: "#CBCAD7",
        borderTopLeftRadius: "0.375rem",
        borderBottomLeftRadius: "0.375rem",
        backgroundColor: disabled ? "#D2D6DB80" : "#FFFFFF",
      }}
      inputStyle={{
        width: "100%",
        height: "44px",
        borderColor: "#CBCAD7",
        backgroundColor: disabled ? "#D2D6DB80" : "#FFFFFF",
        borderRadius: "0.375rem",
        ...inputStyle,
      }}
    />
  );
};

export default CountryPhoneInput;
